// @flow
import * as React from 'react';
import { detectExperiment, setExperiment } from '../../redux/modules/googleOptimize';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import type { ExtractReturn } from '../../types/redux';
import { getUserExperimentVariant } from '../../redux/modules/userVariantTest';
import { setUseGeoLocation } from '../../redux/modules/search';

type OwnProps = $ReadOnly<{||}>;

const mapStateToProps = state => {
    const userExperiment = getUserExperimentVariant(state, 'LOG0fFiUTUyn3DH5w_OFLw');
    const useGeo = Boolean(userExperiment.variantId);
    return {
        useGeo,
        userExperiment,
    };
};

type ReduxProps = $ReadOnly<{|
    ...ExtractReturn<typeof mapStateToProps>,
    useGeo: boolean,
    userExperiment: any,
|}>;

type ReduxActions = $ReadOnly<{|
    detectExperiment: Function,
    setExperiment: Function,
    setUseGeoLocation: Function,
|}>;

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            detectExperiment,
            setExperiment,
            setUseGeoLocation,
        },
        dispatch
    );

type Props = $ReadOnly<{|
    ...OwnProps,
    ...ReduxProps,
    ...ReduxActions,
|}>;

class GeoLocationSearchExperimentContainer extends React.Component<Props> {
    componentDidMount() {
        this.setupGeoLocationSearchExperiment();
    }

    setupGeoLocationSearchExperiment = () => {
        const { useGeo, userExperiment } = this.props;
        const { experimentId, variantId } = userExperiment;
        this.props.setUseGeoLocation(useGeo);
        this.props.setExperiment(`${experimentId}.${variantId}`);
        this.props.detectExperiment();
    };

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GeoLocationSearchExperimentContainer);
